import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER, Z_SCALE } from 'radiance-ui/lib/constants';
import { TYPOGRAPHY_STYLE } from 'radiance-ui';
import { css } from '@emotion/react';

import { LOCAL_COLORS } from 'styles/constants';
import getContrastingColor from 'utils/getContrastingColor';

export const MainBox = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin-right: ${SPACER.large};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: ${Z_SCALE.e3};

  :last-child {
    margin-right: 0;
  }

  ${MEDIA_QUERIES.mdUp} {
    cursor: pointer;
    margin-right: ${SPACER.x3large};
    margin-bottom: ${SPACER.large};
  }
`;

export const IngredientName = styled.div<{
  isActive: boolean;
  titleColor?: string;
}>`
  ${({ theme }) => TYPOGRAPHY_STYLE.caption(theme)};
  line-height: 24px;
  margin-top: ${SPACER.medium};
  position: relative;
  z-index: ${Z_SCALE.e3};
  padding: ${({ isActive }) => (isActive ? '0px 6px' : '0')};
  background-color: ${({ isActive, titleColor }) =>
    isActive && titleColor ? titleColor : ''};
  color: ${({ titleColor, isActive }) =>
    titleColor
      ? isActive
        ? getContrastingColor(titleColor)
        : titleColor
      : 'var(--text-color)'};

  opacity: ${({ isActive }) => (isActive ? 1 : 0.6)};
  font-weight: ${({ isActive }) =>
    isActive ? ({ theme }) => theme.TYPOGRAPHY.fontWeight.bold : ''};
  box-shadow: ${({ isActive, titleColor }) =>
    isActive || titleColor === LOCAL_COLORS.corePurple600
      ? `inset 0 -2px 0 0 ${titleColor}`
      : 'none'};
`;

export const IngredientCircle = styled.div<{
  backgroundColor: string;
  titleColor?: string;
}>`
  width: 124px;
  height: 124px;
  border-radius: 100%;
  border: ${({ titleColor }) =>
    titleColor === LOCAL_COLORS.corePurple600
      ? `1px solid ${LOCAL_COLORS.surfaceBrandLight}`
      : `1px solid ${LOCAL_COLORS.surfaceLight}`};
  background: ${({ backgroundColor }) =>
    backgroundColor === LOCAL_COLORS.surfaceWhite
      ? LOCAL_COLORS.surfaceWhite
      : LOCAL_COLORS.surfaceLight};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const ingredientImgStyles = css`
  width: 80px;
  height: 80px;
`;
